var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page"},[_c('div',{staticClass:"img"},[_c('img',{attrs:{"src":require("./img/success.png"),"alt":""}}),_c('div',{staticClass:"message"},[_vm._v("已经提交成功，请耐心等待工作人员联系您～")]),_c('div',{staticClass:"btn",on:{"click":_vm.goBack}},[_vm._v("返回")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }